import React, { PropTypes } from 'react';
import ReactGA from 'react-ga';
import en from '../../../assets/images/panorama-en.jpg';
import es from '../../../assets/images/panorama-es.jpg';
import pt from '../../../assets/images/panorama-pt.jpg';

const propTypes = {
  locale: PropTypes.string.isRequired,
};


const Panorama = (props) => {
  let img;
  switch (props.locale) {
    case 'pt':
      img = pt;
      break;
    case 'es':
      img = es;
      break;
    default:
      img = en;
  }

  const handleClick = () => {
    ReactGA.event({
      category: 'Ads',
      action: 'Clicou em Banner Panorama',
    });
  };

  return (
    <div className="bottom aligned row">
      <div className="column">
        <img onClick={handleClick} src={img} alt="Panorama" className="banner" />
      </div>
    </div>
  );
};

Panorama.propTypes = propTypes;

export default Panorama;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/Panorama.js
 **/